export default {
  new_tag: 'Nouveau',
  groups: {
    dashboards: 'Tableaux de bord',
    online_shop: 'Boutique en ligne',
    home: 'Accueil',
    marketing: 'Marketing',
    reservations: 'Réservations',
    website: 'Site web',
    orders_portal: 'Ouvrir le portail de commandes',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Application mobile',
    phone_answering: 'Réponse téléphonique',
    pricing: 'Tarification',
    team: 'Équipe',
    data_deletion_requests: 'Demandes de suppression de données',
    partner: 'Partenaire',
  },
  get_started: {
    title: 'Démarrer',
  },
  onboarding: {
    title: 'Lancement',
  },
  new_restaurant: {
    title: 'Nouveau restaurant',
  },
  gift_cards: {
    title: 'Cartes cadeaux',
  },
  top_items: {
    title: 'Articles populaires',
  },
  dashboards: {
    title: 'Tableaux de bord',
    children: {
      general: 'Général',
      restaurant_details: 'Détails du restaurant',
      external_delivery: 'Livraison externe',
      overview: 'Aperçu',
      orders: 'Commandes par source',
      google: 'Google',
      customers: 'Clients',
    },
  },
  customer_base: {
    title: 'Base clients',
  },
  new_company: {
    title: 'Nouveau restaurant',
  },
  agent_ops_queue: {
    title: 'Suggestions IA',
  },
  external_delivery_support: {
    title: 'Support livraison externe',
  },
  payment_gateways: {
    title: 'Passerelles de paiement',
  },
  developers: {
    title: 'Développeurs',
  },
  feature_flags: {
    title: 'Indicateurs de fonctions',
  },
  platform_agent_log: {
    title: 'Journal Amigo',
  },
  test_restaurants: {
    title: 'Restaurants test',
  },
  partners: {
    title: 'Partenaires',
  },
  partner: {
    children: {
      account: 'Compte',
      branding: 'Image de marque',
      payment_gateway: 'Passerelle de paiement',
      billing: 'Facturation',
      tax_currency: 'Taxe et devise',
      service_fee_calculator: 'Calculateur de frais de service',
      processing_fees: 'Frais de traitement',
    },
  },
  going_live: {
    title: 'Mise en ligne',
    children: {
      setup_package_fulfillments: 'Expéditions Logsta',
      polygraphy: 'Produits imprimés',
    },
  },
  franchises: {
    title: 'Marques',
  },
  setup_package_fulfillments: {
    title: 'Expéditions du pack de configuration',
  },
  website: {
    title: 'Site web',
    children: {
      storefront: 'Vitrine',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Réservation',
    children: {
      overview: 'Aperçu',
      booking_availability: 'Disponibilités de réservation',
      settings: 'Paramètres',
      general: 'Général',
      storefront: 'Vitrine',
    },
  },
  subscriptions: {
    title: 'Abonnements',
    children: {
      subscriptions: 'Abonnements',
      products: 'Produits',
    },
  },
  sales: {
    title: 'Ventes',
    children: {
      orders: 'Commandes',
      receipts: 'Reçus clients',
      external_deliveries: 'Livraisons externes',
    },
  },
  billing: {
    title: 'Rapports',
    children: {
      monthly_statements: 'Relevés mensuels',
      payouts: 'Versements',
      invoices: 'Factures',
      subscription: 'Abonnement',
      sales_summary: 'Récapitulatif des ventes',
      internal_invoice_items: 'Éléments de facture interne',
      income_reports: 'Rapports de revenus',
      tax_reports: 'Rapports fiscaux',
    },
  },
  master_menu: {
    title: 'Synchro marque',
  },
  menu: {
    title: 'Menu',
    children: {
      master_overview: 'Marques',
      manage_menus: 'Gérer les menus',
      modifiers: 'Modificateurs',
      smart_pricing: 'Tarification intelligente',
      upsell_items: 'Articles de vente incitative',
      sold_out_items: 'Articles épuisés',
      import: 'Importer',
      edit_history: 'Historique des modifications',
    },
  },
  my_store: {
    title: 'Mes informations',
    children: {
      settings: 'Profil',
      gallery: 'Galerie',
      business_information: 'Informations commerciales',
      documents: 'Mes documents',
      personal_information: 'Informations personnelles',
      bank_info: 'Coordonnées bancaires',
      tax_info: 'Informations fiscales',
      shipping_info: 'Informations de livraison',
      google_profile: 'Profil Google',
      seo: 'SEO',
      impressum: 'Mentions légales',
      imprint: 'Mentions légales',
      post_launch: 'Post-lancement',
      tax_currency: 'Taxe et devise',
    },
  },
  opening_hours: {
    title: 'Horaires & Localisation',
    children: {
      opening_hours: "Horaires d'ouverture",
      location: 'Localisation',
    },
  },
  order_settings: {
    title: 'Paramètres de commande',
    children: {
      takeout: 'Modes de commande',
      missed_orders: 'Commandes manquées',
      order_layout: 'Disposition des commandes',
      payment_methods: 'Modes de paiement',
      connect_paypal: 'Connecter PayPal',
      tips: 'Pourboires',
      service_fee: 'Frais',
      processing_fees: 'Frais de traitement',
      receipt: 'Reçu',
      staff_credentials: 'Identifiants du personnel',
      integrations: 'Intégrations',
      terminal: 'Terminal',
      invoices: 'Factures',
    },
  },
  mobile_app: {
    title: 'Application mobile',
    children: {
      overview: 'Aperçu',
      updates: 'Mises à jour',
      intro_screen: "Écran d'accueil",
    },
  },
  marketing: {
    children: {
      overview: 'Aperçu',
      followers: 'Abonnés',
      email_messages: 'Messages e-mail',
      push_notifications: 'Notifications push',
      promo_codes: 'Codes promo',
      offers: 'Offres',
      google_business: 'Google Business',
      google_review_program: "Programme d'avis Google",
      loyalty_program: 'Programme de fidélité',
      polygraphy: 'Produits imprimés',
      tracking_links: 'Liens de suivi',
      google_ads: 'Google Ads',
      website_analytics: 'Analyses du site web',
      featured_posts: 'Posts Application mobile',
    },
  },
  loyalty_tablet: {
    title: 'Tablette de fidélité',
    children: {
      dashboard: 'Tableau de bord',
      settings: 'Paramètres',
      credentials: 'Identifiants',
    },
  },
  contract: {
    title: 'Contrat',
    children: {
      agreement: 'Accord',
      template: 'Modèle',
    },
  },
  team: {
    children: {
      managers: 'Gestionnaires',
      reports: 'Rapports',
    },
  },
};
